import script from "./concept.vue?vue&type=script&setup=true&lang=js"
export * from "./concept.vue?vue&type=script&setup=true&lang=js"

import "./concept.vue?vue&type=style&index=0&id=64af1231&lang=less"
import "./concept.vue?vue&type=style&index=1&id=64af1231&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/www.7pa.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64af1231"]])

export default __exports__